import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
	兼容手Q/微信/QQ浏览器相关的jsBridge平台
	支持自有客户端按照milo规范注入jsbridge调用
*/
import loader from '../../common/loader';
import { isFunction, isObject, isString } from '../../common/base';

var isQQApp = function isQQApp() {
  var sUserAgent = navigator.userAgent;
  var REGEXP_IOS_QQ = new RegExp('(iPad|iPhone|iPod).*? (IPad)?QQ\\/([\\d\\.]+)');
  var REGEXP_ANDROID_QQ = new RegExp('\\bV1_AND_SQI?_([\\d\\.]+)(.*? QQ\\/([\\d\\.]+))?', 'ig'); // 判断是否是IOSQQ 或者 AndroidQQ打开

  var isIphoneOs_QQ = REGEXP_IOS_QQ.test(sUserAgent);
  var isAndroid_QQ = REGEXP_ANDROID_QQ.test(sUserAgent);

  if (isIphoneOs_QQ || isAndroid_QQ) {
    return true;
  }

  return false;
};

var isWxApp = function isWxApp() {
  return /MicroMessenger/ig.test(navigator.userAgent);
};

var isTBS = function isTBS() {
  return /TBS/ig.test(navigator.userAgent);
};

var isQQBrowser = function isQQBrowser() {
  if (isWxApp() || isQQApp() || isTBS()) {
    return false;
  }

  return /MQQBrowser/ig.test(navigator.userAgent);
};

var oParams = {
  apiList: ['env.*', 'app.isInstallApk', 'app.loadAppUrl', 'app.installApk']
};
/* 微信jsbridge 加载相关  --start*/

var arrWeixinJSBridgeCb = [];
var wxBridgeReadyState = 0; // 0 还未谁知ready 1 已设置ready  2 已ready

function getWeixinJSBridge(callback) {
  if (isFunction(callback)) {
    arrWeixinJSBridgeCb.push(callback);
  }

  if (2 == wxBridgeReadyState || window.WeixinJSBridge) {
    if (window.WeixinJSBridge) {
      while (arrWeixinJSBridgeCb.length) {
        var cb = arrWeixinJSBridgeCb.shift();
        isFunction(cb) && cb(window.WeixinJSBridge);
      }
    }
  } else {
    if (1 == wxBridgeReadyState) {
      return;
    }

    document.addEventListener('WeixinJSBridgeReady', function () {
      wxBridgeReadyState = 2;
      getWeixinJSBridge();
    });
    wxBridgeReadyState = 1;
  }
}
/* 微信jsbridge 加载相关  --end*/
// 获取环境


function getEnv() {
  if (isQQApp()) {
    return 'qq';
  }

  if (isWxApp()) {
    return 'wx';
  }

  if (isQQBrowser()) {
    return 'qb';
  }

  return 'others';
}

var jsBridge = {
  sEnv: function sEnv() {
    return getEnv();
  },

  /*
        params:{
            apiList:[]//qqbrowser需要，表示需要用到的api列表
            scheme:{string} 或者 {object}  表示ios中用到的urlscheme 如果为object，则为这种结构：{qq:'',wx:'',qb:'',others:''}
            appleId:{string} 苹果id
        }
    */
  initPlatform: function initPlatform(callback, params) {
    if (isObject(params)) {
      oParams = _objectSpread(_objectSpread({}, oParams), params);
    } // 在手Q中


    if (isQQApp()) {
      if (window.mqq && window.mqq.QQVersion) {
        isFunction(callback) && callback({
          isInit: true,
          bridge: window.mqq
        });
      } else {
        loader.loadScript('https://pub.idqqimg.com/qqmobile/qqapi.js?_bid = 2538').then(function (isLoad) {
          if (!isLoad) {
            isFunction(callback) && callback({
              isInit: false
            });
            return;
          }

          if (window.mqq && window.mqq.QQVersion) {
            isFunction(callback) && callback({
              isInit: true,
              bridge: window.mqq
            });
          } else {
            isFunction(callback) && callback({
              isInit: false
            });
          }
        });
      }
    } else if (isWxApp()) {
      // 微信中
      getWeixinJSBridge(function (bridge) {
        if (!bridge) {
          isFunction(callback) && callback({
            isInit: false
          });
          return;
        }

        isFunction(callback) && callback({
          isInit: true,
          bridge: bridge
        });
      });
    } else if (isQQBrowser()) {
      if (window.browser && window.browser.env && window.browser.env.version) {
        isFunction(callback) && callback({
          isInit: true,
          bridge: window.browser
        });
      } else {
        var apiList = oParams.apiList || [];
        var sApiList = apiList.length ? apiList.join(',') : '*';
        loader.loadScript("https://jsapi.qq.com/get?api=".concat(sApiList)).then(function (isLoad) {
          if (!isLoad) {
            isFunction(callback) && callback({
              isInit: false
            });
            return;
          }

          if (window.browser && window.browser.env && window.browser.env.version) {
            isFunction(callback) && callback({
              isInit: true,
              bridge: window.browser
            });
          } else {
            isFunction(callback) && callback({
              isInit: false
            });
          }
        });
      }
    } else {
      // 有注入milo制定的jsBridge
      if (window.miloAppJsBridge && isObject(window.miloAppJsBridge)) {
        isFunction(callback) && callback({
          isInit: true,
          bridge: window.miloAppJsBridge
        });
      } else {
        // 未注入milo制定的jsBridge
        isFunction(callback) && callback({
          isInit: true,
          bridge: null
        });
      }
    }
  },
  // app 相关,目前只支持ios
  app: {
    top: null,
    // 指定app是否已安装
    isInstalled: function isInstalled(callback, params) {
      var self = this;
      var scheme = params && params.scheme || oParams.scheme;
      var webviewType = getEnv();

      if (isObject(scheme)) {
        scheme = scheme[webviewType];
      }

      if (scheme && isString(scheme)) {
        self.top.initPlatform(function (result) {
          if (!result.isInit) {
            isFunction(callback) && callback(false);
            return;
          }

          var oBridge = result.bridge;

          switch (webviewType) {
            case 'qq':
              oBridge.app.isAppInstalled(scheme, function (result) {
                if (result) {
                  isFunction(callback) && callback(true);
                } else {
                  isFunction(callback) && callback(false);
                }
              });
              break;

            case 'wx':
              oBridge.invoke('getInstallState', {
                packageUrl: scheme
              }, function (res) {
                if (res && res.result && res.result[scheme]) {
                  isFunction(callback) && callback(true);
                } else {
                  isFunction(callback) && callback(false);
                }
              });
              break;

            case 'qb':
              oBridge.app.isInstallApk(function (res) {
                isFunction(callback) && callback(!!res);
              }, {
                apkKey: scheme
              });
              break;

            default:
              if (oBridge && oBridge.app && isFunction(oBridge.app.isInstalled)) {
                oBridge.app.isInstalled(function (res) {
                  isFunction(callback) && callback(res);
                }, {
                  scheme: scheme
                });
              } else {
                isFunction(callback) && callback(false);
              }

              break;
          }
        });
      } else {
        isFunction(callback) && callback(false);

        if ('others' != webviewType) {
          throw '请传入scheme';
        }
      }
    },
    // 打开指定app
    launchApp: function launchApp(callback, params) {
      var self = this;
      var scheme = params && params.scheme || oParams.scheme;
      var appid = params && params.appid || oParams.appid;
      var webviewType = getEnv();

      if (isObject(scheme)) {
        scheme = scheme[webviewType];
      }

      if (isObject(appid)) {
        appid = appid[webviewType];
      }

      if (/^(qq|qb)$/.test(webviewType) && !scheme) {
        throw '请传入scheme';
      }

      if ('wx' == webviewType && !appid) {
        throw '请传入appid';
      }

      self.top.initPlatform(function (result) {
        if (!result.isInit) {
          isFunction(callback) && callback(false);
        }

        var oBridge = result.bridge;

        switch (webviewType) {
          case 'qq':
            oBridge.app.launchApp(scheme, {
              type: 2
            }); // iOS

            isFunction(callback) && callback(true);
            break;

          case 'wx':
            oBridge.invoke('launch3rdApp', {
              appID: appid,
              messageExt: ''
            }, function () {
              isFunction(callback) && callback(true);
            });
            break;

          case 'qb':
            oBridge.app.loadAppUrl(function () {
              isFunction(callback) && callback(true);
            }, function () {
              isFunction(callback) && callback(false);
            }, {
              // key:appleId,
              url: scheme
            });
            break;

          default:
            if (oBridge && oBridge.app && isFunction(oBridge.app.launchApp)) {
              oBridge.app.launchApp(function (res) {
                isFunction(callback) && callback(res);
              }, {
                scheme: scheme
              });
            } else {
              isFunction(callback) && callback(false);
            }

            break;
        }
      });
    },
    // 下载app/打开appstore
    installApp: function installApp(callback, params) {
      var self = this;
      var appleId = params && params.appleId || oParams.appleId;

      if (!appleId) {
        throw '请传入appleId';
      }

      self.top.initPlatform(function (result) {
        if (!result.isInit) {
          isFunction(callback) && callback(false);
          return;
        }

        var oBridge = result.bridge;
        var webviewType = getEnv();

        switch (webviewType) {
          case 'qq':
            oBridge.app.downloadApp({
              appid: appleId
            }, function () {
              isFunction(callback) && callback(true);
            });
            break;

          case 'wx':
            oBridge.invoke('launchApplication', {
              schemeUrl: "itms-apps://itunes.apple.com/app/id".concat(appleId)
            }, function () {
              isFunction(callback) && callback(true);
            });
            break;

          case 'qb':
            oBridge.app.installApk({
              appURL: "https://itunes.apple.com/cn/app/id".concat(appleId, "?mt=8")
            });
            isFunction(callback) && callback(true);
            break;

          default:
            if (oBridge && oBridge.app && isFunction(oBridge.app.installApp)) {
              oBridge.app.installApp(function (res) {
                isFunction(callback) && callback(res);
              }, {
                appleId: appleId
              });
            } else {
              // 允许跳转的控制函数
              if (isFunction(params.canJump) && params.canJump()) {
                location.href = "itms-apps://itunes.apple.com/app/id".concat(appleId);
              }
            }

            break;
        }
      });
    }
  },
  // ui 相关
  ui: {
    top: null,
    oVChangeCb: {},
    isVCInit: false,
    // 页面可见性发生变化
    addVisibilityChangeEvent: function addVisibilityChangeEvent(cb) {
      var self = this;
      var eventId = "ui_vc_".concat(Math.ceil(1000000 * Math.random()));

      while (self.oVChangeCb[eventId]) {
        eventId = "ui_vc_".concat(Math.ceil(1000000 * Math.random()));
      }

      self.oVChangeCb[eventId] = cb;

      if (self.isVCInit) {
        return;
      }

      var webviewType = getEnv();

      if (webviewType == 'qq') {
        document.addEventListener('qbrowserVisibilityChange', function (e) {
          var isVisible = !e.hidden;

          for (var id in self.oVChangeCb) {
            if (isFunction(self.oVChangeCb[id])) {
              self.oVChangeCb[id]({
                isVisible: isVisible
              });
            }
          }
        });
        self.isVCInit = true;
      } else {
        document.addEventListener('visibilitychange', function () {
          var isVisible = !document.hidden;

          for (var id in self.oVChangeCb) {
            if (isFunction(self.oVChangeCb[id])) {
              self.oVChangeCb[id]({
                isVisible: isVisible
              });
            }
          }
        });
        self.isVCInit = true;
      }
    },
    removeVisibilityChangeEvent: function removeVisibilityChangeEvent(eventId) {
      // eslint-disable-next-line no-prototype-builtins
      if (isString(eventId) && this.oVChangeCb.hasOwnProperty(eventId)) {
        delete this.oVChangeCb[eventId];
      }
    }
  }
}; // 指向环境

jsBridge.app.top = jsBridge;
jsBridge.ui.top = jsBridge;
export default jsBridge;